import { isNullOrUndefined } from 'utils/Global';
import {
  GridDTO,
  GridLayerDTO,
  LayerDetailsDTO,
  LayerDTO,
  LayerTypeDTO,
  ScreenLot,
} from 'business/models/Models';

export default async function GenerateEmptyPlates(data) {
  for (let row = 1; row <= data.docData.rowCount; row++) {
    for (let column = 1; column <= data.docData.colCount; column++) {
      let plate = GetPlate(data.docData.plateDto, row, column);

      if (plate === null) {
        plate = CreateNewPlateAt(data, row, column);
      } else {
        if (!data.docData.IsCotainerScreenLotPlate) {
          // if plate exists and no corresponding ExperimentPlate exists
          if (plate.experimentPlate == undefined) {
            CreateNewExperimentPlate(data, plate);
          }
        } else if (!data.docData.isCotainerScreenLotPlate) {
          // if plate exists and no corresponding ScreenLotPlate exists
          if (plate.GetScreenLotPlateRows().Length == 0) {
            let initialScreenLotRow: ScreenLot = await GetInitialScreenLot(data);
            if (initialScreenLotRow == null) {
              initialScreenLotRow = await CreateInitialScreenLot(data, null);
            }
            CreateDefaultScreenLotPlate(data, initialScreenLotRow, plate);
          }
        }
      }
    }
  }
}

async function GetInitialScreenLot(data): Promise<ScreenLot> {
  let initialScreenLotRow: ScreenLot = null;
  data.docData.ScreenLots.forEach((screenLot) => {
    if (screenLot.InitialLot == true) {
      initialScreenLotRow = screenLot;
      return initialScreenLotRow;
    }
  });

  return initialScreenLotRow;
}

async function CreateNewPlateAt(data, rowPosistion, colPosition) {
  let plate: any;

  plate.State = 0;
  plate.PlateNumber = (rowPosistion - 1) * data.docData.colCount + colPosition;
  plate.TreeNodeID = -1;
  plate.IsQueued = false;
  plate.CanvasRowPosition = rowPosistion;
  plate.CanvasColumnPosition = colPosition;

  data.docData.plateDto.push(plate);

  data.docData.PlatVM.push(plate);

  // If new plate is for experiment then create experiment plate otherwise create screen lot and screen lot plate.
  if (!data.docData.IsCotainerScreenLotPlate) {
    CreateNewExperimentPlate(data, plate);
  } else {
    let initialScreenLotRow: ScreenLot = await GetInitialScreenLot(data); // why trying to get when we know its new screen lot plate
    if (initialScreenLotRow == null) {
      initialScreenLotRow = await CreateInitialScreenLot(data, null);
    }
    CreateDefaultScreenLotPlate(data, initialScreenLotRow, plate);
  }

  return plate;
}

async function CreateNewExperimentPlate(data, plateRow) {
  return;
}

async function CreateInitialScreenLot(data, plateRow): Promise<ScreenLot> {
  const initialScreenLotRows: ScreenLot[] =
    data.docData.ScreenLot.Select(' InitialLot = true ');
  let initialScreenLotRow = null;
  if (initialScreenLotRows.length > 0) {
    initialScreenLotRow = initialScreenLotRows[0];
  } else {
    initialScreenLotRow = CreateDefaultScreenLotRow(data, null);
  }

  return initialScreenLotRow;
}

async function CreateDefaultScreenLotPlate(data, initialScreenLotRow, plateRow) {
  return;
}
async function CreateDefaultScreenLotRow(data, experimentRow): Promise<ScreenLot> {
  let screenLotRow: ScreenLot;
  screenLotRow.experimentId = experimentRow.Id;
  screenLotRow.containerId = experimentRow.ContainersRow.Id;
  screenLotRow.treeNodeId = -1;
  screenLotRow.dispenseVolume = experimentRow.ContainersRow.DefaultWellVolume; // initialize it or let it be null?
  screenLotRow.currentVolume = 0; // initialize it or let it be null?
  screenLotRow.initialLot = true;
  screenLotRow.comment = 'Default Lot';

  if (data.docData.experiment.MaxLotNumber == null) {
    data.docData.experiment.MaxLotNumber = 0;
  }
  screenLotRow.lotNumber = data.docData.experiment.MaxLotNumber;
  data.docData.experiment.MaxLotNumber++;

  data.docData.ScreenLots.push(screenLotRow);
  return screenLotRow;
}

export function GetPlate(plates, rowPos, colPos) {
  let foundPlate = null;

  for (const i in plates) {
    if (plates[i].rowPos === rowPos && plates[i].colPos === colPos) {
      foundPlate = plates[i];
      return foundPlate;
    }
  }

  return foundPlate; // no plate found at given position
}

export async function GenerateEmptyWells(data) {
  return;
}
export async function GenerateEmptyWellDrops(data) {
  return;
}

export function getUniqueLayerName(layers, baseLayerName) {
  //generateUniqueLayerName
  let unique = false;
  let nameIndex = 1;
  const layerName = baseLayerName;
  let uniqueName = '';

  while (!unique) {
    unique = true;
    uniqueName = layerName + ' ' + nameIndex;

    for (let i = 0; i < layers.length; i++) {
      if (uniqueName == layers[i].name) {
        unique = false;
        nameIndex++;
        break;
      }
    }
  }

  return uniqueName;
}

export function getUniqueProteinLayerName(
  layers,
  baseLayerName,
  nameProteinLayerUsingPFName,
  currentlayerId,
) {
  const proteinLayers = layers.filter(
    (layer) => layer.type === LayerTypeDTO.Protein && layer.id !== currentlayerId,
  );
  let unique = false;
  let nameIndex = 1;
  const layerName = nameProteinLayerUsingPFName ? baseLayerName : 'Protein Layer ';
  let uniqueName = '';
  while (!unique) {
    unique = true;
    uniqueName = layerName + ' ' + nameIndex;

    for (let i = 0; i < proteinLayers.length; i++) {
      if (uniqueName == proteinLayers[i].name) {
        unique = false;
        nameIndex++;
        break;
      }
    }
  }

  return uniqueName;
}

export function getLinkedLayerUniqueName(docData, layer) {
  const parentLayer = docData.filter(
    (lyr) =>
      lyr.type == LayerTypeDTO.Grid &&
      lyr.layerDetail.gridId == layer.layerDetail.gridId &&
      lyr.layerDetail.subGridNumber == 1,
  )[0];
  const uniqueName =
    parentLayer.name + ' {' + (layer.layerDetail.subGridNumber - 1) + '}';
  return uniqueName;
}

export function getLinkedLayerGridDto(
  layers: LayerDTO[],
  layerDetail: LayerDetailsDTO,
): GridDTO {
  const gridLayer = layerDetail as GridLayerDTO;
  const gridLayers: GridLayerDTO[] = layers
    .filter((lyr) => lyr.type == LayerTypeDTO.Grid && !isNullOrUndefined(lyr.layerDetail))
    .map((lyr) => lyr.layerDetail as GridLayerDTO);
  const parentGridLayer = gridLayers.find(
    (gl) => gl.gridId === gridLayer.gridId && gl.subGridNumber === 1,
  );
  if (isNullOrUndefined(parentGridLayer) || isNullOrUndefined(parentGridLayer.grid)) {
    return gridLayer.grid;
  }

  return parentGridLayer.grid;
}

export function isOverlappingLayer(
  layer: LayerDTO,
  operandLayer: LayerDTO,
  includeLinkedLayers = false,
): boolean {
  if (
    operandLayer.x > layer.x + layer.width ||
    operandLayer.x + operandLayer.width < layer.x ||
    operandLayer.y > layer.y + layer.height ||
    operandLayer.y + operandLayer.height < layer.y
  ) {
    if (
      includeLinkedLayers &&
      operandLayer.type == LayerTypeDTO.Grid &&
      layer.type == LayerTypeDTO.Grid &&
      (operandLayer.layerDetail as GridLayerDTO).gridId ==
        (layer.layerDetail as GridLayerDTO).gridId
    ) {
      return true;
    }
    return false;
  }
  return true;
}
